import { SidebarHeader, SidebarLinks, SidebarStatus } from './SidebarNav';

export function Sidebar() {
  return (
    <aside className="hidden md:flex flex-col w-56 shrink-0 border-r border-zinc-800/80 bg-zinc-950">
      <SidebarHeader />
      <SidebarLinks />
      <div className="mt-auto">
        <SidebarStatus />
      </div>
    </aside>
  );
}
